import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { EnvironmentService } from '@core/services/environment-configuration.service';
import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => {
      const configService = inject(EnvironmentService);
      configService.setConfig(environment);
    }),

    // Http
    provideHttpClient(),

    // Router
    provideRouter(appRoutes),

    // Optimized zone
    provideZoneChangeDetection({ eventCoalescing: true }),

    // Animations optimized
    provideAnimationsAsync()
  ]
};
